module.exports = __webpack_public_path__ + "img/INSIGHTS (4).bb256eb4.png";